'use strict';

import {Subject, combineLatest} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

/**
 * SPEC-2816
 *
 * Whole file disabled, apart from initializing the controller so the template can be used.
 *
 * The new Project Info page is fully converted to Angular, however it's rendered withing a
 * wrapper of AngularJS. It should not be that much trouble to remove the wrapper, see the
 * Elements page for example, but it probably messes up the stylesheets. Disabling this file
 * gives the same result: performance boost, and removal of any old dependency.
 */
(function () {
  angular
    .module('specsguardApp')
    .controller('ProjectInfoCtrl', ProjectInfoCtrl);

  // ProjectInfoCtrl.$inject = ['$scope', '$anchorScroll', '$mdDialog', 'Auth', '$document',
  //   'errorMessageService', '$stateParams', 'Constants', 'Labels', '$location', '$log', '$filter', 'EditorConfig',
  //   'SimpleDialogFormService', '$timeout', 'sg2ModalService', 'ProjectStore', 'ProjectElementStore', 'Utils',
  //   'ProjectModuleStore', 'ProjectSubmoduleStore', 'BuildingStore', 'ElementLogStore', 'ProjectStoreService',
  //   'sg2ProjectElementService', 'sg2ProjectModuleService', 'sg2ProjectSubmoduleService', '$injector', 'sg2ModuleService'];

  // function ProjectInfoCtrl($scope, $anchorScroll, $mdDialog, Auth, $document, errorMessageService, $stateParams,
  //                          Constants, Labels, $location, $log, $filter, EditorConfig, SimpleDialogFormService,
  //                          $timeout, sg2ModalService, projectStore, projectElementStore, Utils,
  //                          projectModuleStore, projectSubmoduleStore, buildingStore, elementLogStore, ProjectStoreService,
  //                          sg2ProjectElementService, sg2ProjectModuleService, sg2ProjectSubmoduleService, $injector, sg2ModuleService) {

  ProjectInfoCtrl.$inject = [];

  function ProjectInfoCtrl() {

//     const vm = this;

//     // Make sure we unsubscribe for the observers
//     vm.destroy$ = new Subject();

//     const project = projectStore.get();

//     vm.LABELS = Labels;

//     vm.loading = true;
//     vm.hasResults = true;

//     setTimeout(() => {
//       $scope.sg2AuthService = $injector.get('sg2AuthService');
//     }, 100);

//     vm.knowledgeLevels = Constants.getList('KNOWLEDGE_LEVELS');
//     vm.projectLevels = Constants.getList('PROJECT_LEVELS').filter((pl) => pl.hasTemplateElements);

//     vm.selectedKnowledgeLevel = $stateParams.knowledgeLevel || 'all';
//     vm.selectedProjectLevel = $stateParams.projectLevel || 'all';

//     // Would be nice to remove this, but this will impact initial load time massively
// //    vm.selectedProjectLevel = 1;

//     vm.selectedProjectLevelDisplay = vm.selectedProjectLevel !== 'all' ?
//       (vm.projectLevels.filter((p) => p._id == vm.selectedProjectLevel))[0].displayName : vm.LABELS.getPlural('all');
//     vm.selectedKnowledgeLevelDisplay = vm.selectedKnowledgeLevel !== 'all' ?
//       (vm.knowledgeLevels.filter((p) => {
//         p._id == vm.selectedKnowledgeLevel;
//       }))[0].displayName : vm.LABELS.getPlural('all');

//     const elementsView = {
//       'PvE Document': 'PvE',
//       Projectinformatie: 'project',
//       Gebouwinformatie: 'building',
//     };

//     $scope.elementsView = elementsView[$stateParams.title];

//     // @TODO Dit wordt niet in deze controller/view gebruikt en moet dus verplaatst worden
//     $scope.canWrite = Utils.canWriteProject(Auth.getCurrentUser(),
//       {accessLevel: null, projectLevels: ['manager', 'contributor'], project: project}
//     );

//     // @TODO Dit wordt niet in deze controller/view gebruikt en moet dus verplaatst worden
//     $scope.canWriteOwner = Utils.canWriteProject(Auth.getCurrentUser(),
//       {accessLevel: null, projectLevels: ['manager'], project: project}
//     );

//     vm.projectElements = [];
//     // Throttle loading the elements, so we have time to render the loading screen
//     setTimeout(function () {
//       combineLatest(projectElementStore.state$, projectSubmoduleStore.state$, projectModuleStore.state$).pipe(
//         takeUntil(vm.destroy$)
//       ).subscribe(elementSubscriptionHandler);
//     }, 300);

//     $scope.title = $stateParams.title;
//     $scope.removeSpaces = $filter('removeSpaces');

//     /**
//      * @depricated Until fix for infinite scroll issue (can't scroll to element which isn't loaded into the DOM yet).
//      * @todo Replace lazyloading with Angular7 Virtual Scrolling, which should natively be able to deal with this.
//      */
//     $scope.navigateToEditableElement = function (element) {
//       switch (element.projectLevel) {
//         case 1:
//           $location.path(`/project/${project._id}/info`).hash($scope.removeSpaces(element.code));
//           break;
//         case 2:
//           $location.path(`/project/${project._id}/building/${element.constructionId}/info`)
//             .hash($scope.removeSpaces(element.code));
//           break;
//         default:
//           $log.error('Undefined navigation');
//       }
//     };

//     // showActivity is used in sg-project-info-elements
//     $scope.showActivity = function (element) {
//       const DOMId = 'module-' + element.moduleId + '-submodule-' + element.submoduleId + '-element-' + element._id;
//       $scope.$broadcast('openActivitySidenav', element);
//       anchorScrollToElement(DOMId, element._id, 'element');
//     };

//     $scope.closeActivitySidebar = () => {
//       $scope.$broadcast('closeActivitySidenav');
//     };

//     function anchorScrollToElement(DOMId, elementId, elementType) {
//       $anchorScroll.yOffset = 200;
//       $anchorScroll(DOMId);
//       setSelectedElement(elementId, elementType);

//       // reset
//       $anchorScroll.yOffset = 0;
//     }

//     vm.changeProjectlevel = function (level) {
//       vm.selectedProjectLevel = level;
//       vm.selectedProjectLevelDisplay = vm.selectedProjectLevel !== 'all' ?
//         (vm.projectLevels.filter((p) => p._id == vm.selectedProjectLevel))[0].displayName : vm.LABELS.getPlural('all');

//       vm.loading = true;
//       $timeout(function () {
//         projectElementStore.refresh()
//       });
//     };

//     /**
//      * Handle elementsFilter, start loading indicator then start actual rendering in other thread
//      * @param knowledgeLevelType
//      */
//     vm.elementsFilter = function (knowledgeLevelType) {
//       if (!knowledgeLevelType) {
//         return;
//       }
//       if (knowledgeLevelType !== 'all') {
//         knowledgeLevelType = parseInt(knowledgeLevelType);
//       }
//       vm.selectedKnowledgeLevel = knowledgeLevelType;
//       vm.selectedKnowledgeLevelDisplay = vm.selectedKnowledgeLevel !== 'all' ?
//         (vm.knowledgeLevels.filter((p) => p._id == vm.selectedKnowledgeLevel))[0].displayName :
//         vm.LABELS.getPlural('all');

//       vm.loading = true;
//       $timeout(function () {
//         projectElementStore.refresh();
//       });
//     };

//     function setSelectedElement(id, type) {
//       if (type === 'element') {
//         vm.projectElements.forEach(function (e) {
//           e.selected = e.id === id;
//         });

//         $scope.selectedElement = projectElementStore.get(id);
//       } else {
//         let firstHasBeenSet = false;
//         vm.projectElements.forEach(function (element) {
//           element.selected = false; // make sure we only select the first element from a module / submodule
//           if (!firstHasBeenSet && element[type + 'Id'] === id) {
//             firstHasBeenSet = true;
//             element.selected = true;
//             $scope.selectedElement = projectElementStore.get(element._id);
//           }
//         });
//       }
//     }

//     function determineNodeType(element) {

//       if (!element.length) {
//         return null;
//       }

//       const id = element[0].id;
//       if (id.indexOf('element') > -1) {
//         return 'element';
//       } else if (id.indexOf('submodule') > -1) {
//         return 'submodule';
//       } else if (id.indexOf('module') > -1) {
//         return 'module';
//       }

//       return null;
//     }

//     $scope.getBuildingName = function (element) {
//       if (element.projectLevel !== 2) {
//         return '';
//       }
//       return $scope.project.buildings.find(
//         function (building) {
//           return building._id === element.constructionId;
//         }
//       ).name;
//     };

//     $scope.commentText = '';
//     $scope.submitComment = function () {
//       elementLogStore.insert({
//         elementId: $scope.selectedElement._id,
//         text: $scope.commentText,
//         userId: Auth.getCurrentUser()._id
//       });

//       // Update activity log
//       $scope.$broadcast('updateActivitySidenav', $scope.selectedElement);
//     };

//     if (vm.projectElements && vm.projectElements.length > 0) {
//       setSelectedElement(vm.projectElements[0]._id, 'element');
//     }

//     $scope.createElement = function (element, belowId) {
//       // close directly
//       $mdDialog.hide();
//       element.value = element.qualityLevel.all;

//       return projectElementStore.insert(element).then((res) => {
//         const message = Labels.getLabel('addedspecification');
//         return Promise.resolve({
//           message: message
//         });
//       });
//     };

//     $scope.getCreateElement = () => {
//       const {projectLevel, building_id: buildingId, project_id: projectId} = $stateParams;

//       let ql = project.qualityLevel;

//       if (projectLevel !== 1 && projectLevel !== 'all') {
//         ql = buildingStore.get(buildingId).qualityLevel;
//       }

//       return {
//         projectId: project._id,
//         versionId: project.versionId,
//         quality: ql,
//         projectLevel,
//         constructionId: (projectLevel === 1 || projectLevel === 'all') ? projectId : buildingId,
//         hasInputInstruction: false,
//         hasMultipleQualityLevels: false,
//         inputType: 'Long String',
//         isPresentInPvEDocument: false,
//         requirementType: (projectLevel === 1 || projectLevel === 'all') ? null : 1,
//         requirementStrictness: (projectLevel === 1 || projectLevel === 'all') ? null : 1,
//         knowledgeLevel: 3,
//         appliesToFases: [1, 2, 3, 4],
//         templateValues: [],
//         isCustom: true,
//         isTechnicalType: false,
//         active: true,
//       };
//     };

//     $scope.showCreateElementDialog = (action, element, options = null) => {
//       const {projectLevel} = element;
//       let hiddenFields = [
//         'constructionId', 'inputType', 'logAndComments', 'pveTemplates', 'hasInputInstruction', 'hasMultipleQualityLevels'
//       ];

//       if (projectLevel === 1) {
//         hiddenFields = [...hiddenFields, 'requirementType', 'requirementStrictness'];
//       }
//       if (action === 'copy' || (options && options.noModuleSelection)) {
//         hiddenFields = [...hiddenFields, 'moduleId', 'submoduleId'];
//       }

//       $mdDialog.show({
//         controller: 'SgElementDialogCtrl',
//         controllerAs: '$SgElementDialogCtrl',
//         locals: {
//           title: Labels.getLabel(`${action}element`),
//           saveFunction: $scope[`${action}Element`],
//           hideOverride: false,
//           element,
//           hiddenFields,
//           modules: projectModuleStore.getAll().filter((m) => !m.isTechnicalType),
//           constructions: ProjectStoreService.getConstructions(),
//           projectLevel,
//           appSection: 'template',
//           action,
//           constants: Constants.getAll(),
//           language: projectStore.get().language,
//         },
//         bindToController: true,
//         templateUrl: 'app-legacy/components/sg-element-dialog/sg-element-dialog.tmpl.html',
//         clickOutsideToClose: true,
//       });
//     };

//     $scope.tinyMceReadOnlyOptions = EditorConfig({
//       contentLanguage: project.language,
//       inline: true,
//       readonly: true
//     });

//     vm.nodeClick = (node) => {
//       node.id = node.ref;

//       const element = angular.element($document[0].getElementById(node.ref));
//       anchorScrollToElement(node.ref, element[0].attributes['mongoose-id'].value, node.type);
//     };

//     vm.nodeMenuClick = (event) => {
//       if (event.action === 'rename') {
//         if (event.node.type === 'element') {
//           sg2ProjectElementService.rename(event.node._id);
//         } else if (event.node.type === 'module') {
//           sg2ProjectModuleService.rename(event.node._id);
//         } else if (event.node.type === 'submodule') {
//           sg2ProjectSubmoduleService.rename(event.node._id);
//         }
//       } else if (event.action === 'delete') {
//         if (event.node.type === 'element') {
//           sg2ProjectElementService.delete(event.node._id);
//         } else if (event.node.type === 'module') {
//           sg2ProjectModuleService.delete(event.node._id);
//         } else if (event.node.type === 'submodule') {
//           sg2ProjectSubmoduleService.delete(event.node._id);
//         }
//       }
//     };

//     /**
//      * Function handles the orderd list of elements received from the treeview on sorder change event
//      * And translations it to something the API can handle
//      * @param orderChange .
//      */
//     vm.handleOrderChange = (orderChange) => {

//       // @ Afhandelen sorteer actie, doorvoeren in de rest van de applicatie en naar server sturen
//       let parentContainingOrder;
//       let childGroupName;
//       if (orderChange.node.type === 'element') {
//         parentContainingOrder = projectSubmoduleStore.get(orderChange.node.submoduleId);
//         childGroupName = 'elements';
//       } else if (orderChange.node.type === 'submodule') {
//         parentContainingOrder = projectModuleStore.get(orderChange.node.moduleId);
//         childGroupName = 'submodules';
//       } else {

//         parentContainingOrder = projectStore.get();
//         childGroupName = 'modules';
//       }

//       // now we get the full elements from the submodule in correct order
//       const orderedElements = [];
//       let findElement;
//       for (const orderedElement of orderChange.nodes) {

//         if (orderChange.node.type === 'element' && orderedElement.type === 'element' && orderedElement.submoduleId === orderChange.node.submoduleId) {
//           findElement = projectElementStore.get(orderedElement._id);
//         } else if (orderChange.node.type === 'submodule' && orderedElement.type === 'submodule' && orderedElement.moduleId === orderChange.node.moduleId) {
//           findElement = projectSubmoduleStore.get(orderedElement._id);
//         } else {
//           findElement = projectModuleStore.get(orderedElement._id);
//         }

//         if (findElement) {
//           orderedElements.push(findElement);
//         }

//       }

//       // now update the module/submodule/element
//       parentContainingOrder[childGroupName] = orderedElements;

//       // Hier loop de API anders op stuk
//       for (const el of parentContainingOrder[childGroupName]) {
//         delete el.changes;
//       }

//       if (orderChange.node.type === 'element') {

//         // @TODO Deze delete regel moet weg zodra dit ticket gefixed is SPEC-2195
//         delete parentContainingOrder.order; // Required to trigger sorting of childnodes

//         projectElementStore.order(orderChange.nodes.map(el => el._id));
//         projectSubmoduleStore.update(parentContainingOrder);

//       } else if (orderChange.node.type === 'module') {
//         // Get the new position

//         // Give all modules a new and unique order number
//         for (let x = 0; x < parentContainingOrder[childGroupName].length; x++) {
//           parentContainingOrder[childGroupName][x].order = x + 1;
//         }

//         const i = parentContainingOrder[childGroupName].findIndex(n => n._id === orderChange.node._id);

//         projectElementStore.orderByModule(orderChange.nodes.map(el => el._id));
//         projectModuleStore.update(parentContainingOrder[childGroupName][i]);

//       } else if (orderChange.node.type === 'submodule') {
//         // Get the new position
//         // Give all modules a new and unique order number
//         for (let x = 0; x < parentContainingOrder[childGroupName].length; x++) {
//           parentContainingOrder[childGroupName][x].order = x;
//         }

//         const i = parentContainingOrder[childGroupName].findIndex(n => n._id === orderChange.node._id);
//         //parentContainingOrder[childGroupName][i].order = i;

//         projectElementStore.orderBySubmodule(orderChange.nodes.map(el => el._id));
//         //projectSubmoduleStore.order(orderChange.nodes.map(el => el._id));
//         projectSubmoduleStore.update(parentContainingOrder[childGroupName][i]);

//       }
//     };

//     /**
//      * Track page scrolling to highlight treeview
//      */
//     function trackScrolling() {
//       // Make sure we don't listen twice after a UI update
//       cleanupScrollTracking();

//       // configure the intersection observer instance
//       vm.scrollObserver = new IntersectionObserver(onIntersection, {
//         root: null,
//         rootMargin: '-180px 0px -70% 0px',
//         threshold: 0.1
//       });

//       document.querySelectorAll('.observe-scroll').forEach(target => vm.scrollObserver.observe(target));
//     }

//     /**
//      * When an element scrolls into view, pass it on to the reeview
//      * @param entries
//      */
//     function onIntersection(entries) {
//       entries.every(entry => {
//         if (entry.isIntersecting) {
//           if (entry.target.attributes['data-scroll-ref']) {
//             vm.markedTreeNode = entry.target.attributes['data-scroll-ref'].value;
//           }
//         }
//       });
//     }

//     /**
//      * On navigating away cleanup
//      */
//     function cleanupScrollTracking() {
//       if (vm.scrollObserver) {
//         vm.scrollObserver.disconnect();
//         vm.scrollObserver = null;
//       }
//     }

//     function elementSubscriptionHandler([projectElements, projectSubmodules, projectModules]) {

//       if (!projectElements.length || !projectSubmodules.length || !projectModules.length) {
//         return;
//       }

//       clearTimeout(vm.timer);

//       // @NOTE: Sorteren voor elementen wordt nu in de datastore gedaan op basis van de volgorde in de element array
//       // Dit is performance wise misschien niet ideaal.
//       // Mogelijke oplossingen:
//       // een .order property toevoegen aan elementen
//       // Sorteren in deze functie uitvoeren

//       vm.projectElements = projectElements.filter(pe => pe.active && !pe.disabled && !pe.hide);

//       // Should we filter on building level?
//       if ($stateParams.building_id) {
//         vm.projectElements = vm.projectElements.filter(pe => pe.constructionId === $stateParams.building_id);
//       }

//       // Filter projectLevel
//       if (vm.selectedProjectLevel !== 'all') {
//         vm.projectElements = vm.projectElements.filter(pe => pe.projectLevel === vm.selectedProjectLevel);
//       } else {
//         const plIds = vm.projectLevels.map((pl) => pl._id);
//         vm.projectElements = vm.projectElements.filter(pe => plIds.includes(pe.projectLevel));
//       }

//       // Filter knowledgelevel
//       if (vm.selectedKnowledgeLevel !== 'all') {
//         vm.projectElements = vm.projectElements.filter(pe => pe.knowledgeLevel === vm.selectedKnowledgeLevel);
//       }

//       for (const projectElement of vm.projectElements) {
//         projectElement.moduleName = projectModuleStore.get(projectElement.moduleId).name;
//         projectElement.submoduleName = projectSubmoduleStore.get(projectElement.submoduleId).name;
//       }

//       vm.timer = setTimeout(() => {
//         vm.loading = false;
//         trackScrolling();
//       }, 500);
//     }

//     $scope.$on('$destroy', function () {
//       cleanupScrollTracking();
//       vm.destroy$.next();
//       vm.destroy$.complete();
//     });
  }
})
();
